import React, { useState } from 'react';
import { Crown, Check } from 'lucide-react';
// import { stripeService } from '../../services/stripe';
import type { ModalProps } from '../../types/components';

interface UpgradeModalProps extends ModalProps {
  onUpgrade?: (tierId: string) => Promise<void>;
}

export const UpgradeModal: React.FC<UpgradeModalProps> = ({
  isOpen,
  onClose,
  onUpgrade
}) => {
  const [loading, setLoading] = useState<string | null>(null);
  const [selectedTier, setSelectedTier] = useState<string>('pro');
  
  // const pricingTiers = stripeService.getPricingTiers().filter(tier => tier.id !== 'free');
  const pricingTiers: any[] = [];

  if (!isOpen) return null;

  const handleUpgrade = async (tierId: string) => {
    if (!onUpgrade) return;
    
    setLoading(tierId);
    try {
      await onUpgrade(tierId);
      onClose();
    } catch (error) {
      console.error('Upgrade failed:', error);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="text-center mb-8">
          <Crown className="w-12 h-12 text-yellow-500 mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Upgrade Your Plan</h2>
          <p className="text-gray-600">Choose a plan that works for you</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {pricingTiers.map((tier) => (
            <div
              key={tier.id}
              className={`border-2 rounded-lg p-6 cursor-pointer transition-all ${
                selectedTier === tier.id
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
              onClick={() => setSelectedTier(tier.id)}
            >
              <div className="text-center mb-4">
                <h3 className="text-xl font-bold text-gray-900">{tier.name}</h3>
                <div className="mt-2">
                  <span className="text-3xl font-bold">${tier.price}</span>
                  <span className="text-gray-600">/{tier.interval}</span>
                </div>
              </div>

              <ul className="space-y-3 mb-6">
                {tier.features.map((feature: string, index: number) => (
                  <li key={index} className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-green-500" />
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => handleUpgrade(tier.id)}
                disabled={loading === tier.id}
                className="w-full py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
              >
                {loading === tier.id ? 'Processing...' : `Choose ${tier.name}`}
              </button>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={onClose}
            className="px-6 py-2 text-gray-600 hover:text-gray-800"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};